const USER_ROLES = {
    PUBLIC: 1,
    USER: 2,
    ADMIN: 4,
    SUPER: 8,
};

export default USER_ROLES;
